<div class="footer">
    &copy; Amrize {{currentYear}}
</div>